
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.827 23.572a.747.747 0 01-.23-.036L8.25 18.868a2.234 2.234 0 01-1.361-1.006 2.248 2.248 0 01.328-2.765l1.821-1.821a.744.744 0 011.06 0 .752.752 0 010 1.061l-1.821 1.821a.754.754 0 00-.11.921.743.743 0 00.464.338.732.732 0 01.053.015l12.972 4.22-4.218-12.968a.525.525 0 01-.016-.059.744.744 0 00-.728-.571.748.748 0 00-.531.219l-3.413 3.412 2.122 2.122a.752.752 0 01-.53 1.281.743.743 0 01-.53-.22L8.435 9.491a2.24 2.24 0 01-.93.22h-.04a2.233 2.233 0 01-1.562-.632L1.084 4.26C.657 3.819.433 3.25.443 2.649s.254-1.162.687-1.579c.423-.41.979-.635 1.563-.635s1.14.225 1.563.635l4.782 4.782c.425.41.667.969.677 1.57.006.352-.069.696-.219 1.009l2.194 2.194 3.413-3.412a2.235 2.235 0 011.591-.658c.601 0 1.167.234 1.591.658.285.286.489.642.589 1.033L23.54 22.59a.746.746 0 01-.183.762.744.744 0 01-.53.22zM2.695 1.936a.751.751 0 00-.752.739c-.004.2.071.389.209.533L6.95 8.006a.754.754 0 00.528.205.733.733 0 00.428-.149.493.493 0 01.163-.162.743.743 0 00-.082-.977L3.205 2.139a.739.739 0 00-.51-.203z"}})])
          )
        }
      }
    